import { FC } from 'react'
import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { NumberInput, NumberInputProps } from './NumberInput'

type Props = Omit<NumberInputProps, 'value' | 'onChange'> & {
  name: string
  validate?: FieldValidator<string>
  onChange?: (value: string | number) => void
}

export const NumberInputField: FC<Props> = ({ name, validate, decimal, onChange, ...props }) => {
  const form = useForm()
  const { input, meta } = useField<string>(name, { validate })

  const handleChange = (value: string) => {
    form.change(name, value)
    onChange?.(value)
  }

  const errorMessage = meta.error || meta.submitError || props.error

  return (
    <NumberInput
      {...input}
      onChange={handleChange}
      decimal={decimal}
      {...props}
      error={Boolean(meta.touched && errorMessage)}
      formHelperText={(meta.touched && errorMessage) || undefined}
    />
  )
}
